let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6mMIP")).then(() => parcelRequire('2V7Za'));